import { render, staticRenderFns } from "./WeightSet.vue?vue&type=template&id=55e2f11f&scoped=true"
import script from "./WeightSet.vue?vue&type=script&lang=js"
export * from "./WeightSet.vue?vue&type=script&lang=js"
import style0 from "./WeightSet.vue?vue&type=style&index=0&id=55e2f11f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e2f11f",
  null
  
)

export default component.exports